module.exports = __webpack_public_path__ + "img/icon_cost_reduction.c17b6996.svg";